import { useContext } from "react";
import { Outlet, Link } from "react-router-dom";
import { FaFlask } from "react-icons/fa";
import { AlquileresContext } from "../../context/AlquileresContext";
import { isSandboxMode } from "../../application/firestoreHelpers";
import LoadingState from "./LoadingState";

// Wraps the alquileres routes. Shows the spinner only on the first load --
// later refreshes (after importing an Excel, after migrating to Firestore)
// keep the page mounted so local state like success messages doesn't get lost.
//
// Also renders a top banner whenever sandbox mode is on, so the user never
// forgets that what they're touching isn't real data.
function AlquileresLoadingGuard() {
  const { initialLoaded } = useContext(AlquileresContext);
  if (!initialLoaded) return <LoadingState message="Cargando alquileres..." />;
  return (
    <>
      {isSandboxMode() && (
        <div className="bg-amber-400 text-amber-900 px-4 py-2 text-sm flex items-center justify-between gap-3 sticky top-0 z-40 shadow-sm">
          <span className="inline-flex items-center gap-2 font-medium">
            <FaFlask className="w-3.5 h-3.5" />
            Modo Sandbox activo &mdash; los cambios no se guardan en Firestore
          </span>
          <Link
            to="/dashboard/alquileres/configuracion"
            className="text-xs underline hover:text-amber-700"
          >
            Ir a configuracion
          </Link>
        </div>
      )}
      <Outlet />
    </>
  );
}

export default AlquileresLoadingGuard;
